export default __webpack_public_path__ + "static/media/error_placeholder.1ce2791e.svg";